import IdentifiableDto from 'modules/base/dto/IdentifiableDto';
import NamedDto from 'modules/base/dto/NamedDto';

export class VizsgaFeladatsorTableDto extends IdentifiableDto {
	/**
	 * @module VizsgaFeladatsorTableDto
	 */
	constructor() {
		super();
		/** @type {NamedDto} */
		this.vizsgaVizsgasor = null;
		/** @type {number} */
		this.csoport = null;
		/** @type {number} */
		this.lockIn = null;
	}

	/**
	 * @typedef {Object} _VizsgaFeladatsorTableDtoProps
	 * @property {NamedDto} vizsgaVizsgasor
	 * @property {number} csoport
	 * @property {number} lockIn
	 *
	 * @typedef {import("modules/base/dto/IdentifiableDto").IdentifiableDtoProps & _VizsgaFeladatsorTableDtoProps} VizsgaFeladatsorTableDtoProps
	 */
	/**
	 *
	 * @param {VizsgaFeladatsorTableDtoProps} props
	 * @returns {VizsgaFeladatsorTableDto}
	 */
	setup(props) {
		super.setup(props);
		this.vizsgaVizsgasor = props.vizsgaVizsgasor !== null ? new NamedDto().setup(props.vizsgaVizsgasor) : null;
		this.csoport = props.csoport;
		this.lockIn = props.lockIn;
		return this;
	}
}

export default VizsgaFeladatsorTableDto;
